import React from 'react';

interface IconButtonProps {
  icon: React.ReactNode;
  text: string;
  onClick?: () => void;
  className?: string;
}

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  text,
  onClick,
  className = '',
}) => {
  return (
    <div className={`c-btn-icon ${className}`} onClick={onClick}>
      <div className='c-btn-icon__circle'>{icon}</div>
      <div className='c-btn-icon__text'>{text}</div>
    </div>
  );
};

export default IconButton;
